import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
var EYMMetricMethods;
(function (EYMMetricMethods) {
  EYMMetricMethods["addFileExtension"] = "addFileExtension";
  EYMMetricMethods["extLink"] = "extLink";
  EYMMetricMethods["file"] = "file";
  EYMMetricMethods["hit"] = "hit";
  EYMMetricMethods["notBounce"] = "notBounce";
  EYMMetricMethods["params"] = "params";
  EYMMetricMethods["reachGoal"] = "reachGoal";
  EYMMetricMethods["setUserID"] = "setUserID";
  EYMMetricMethods["userParams"] = "userParams";
})(EYMMetricMethods || (EYMMetricMethods = {}));
export var YaMetricsCounter = /*#__PURE__*/function () {
  function YaMetricsCounter(counterId) {
    _classCallCheck(this, YaMetricsCounter);
    this.counterId = counterId;
  }

  /**
   * Основной метод для отправки reachGoal через window.ym
   */
  _createClass(YaMetricsCounter, [{
    key: "sendParamsEvent",
    value: function sendParamsEvent(params) {
      this.sendRawEvent(EYMMetricMethods.params, params);
    }

    /**
     * Отправка цели
     */
  }, {
    key: "sendReachGoalEvent",
    value: function sendReachGoalEvent(target, params) {
      this.sendRawEvent(EYMMetricMethods.reachGoal, target, params);
    }
  }, {
    key: "sendRawEvent",
    value: function sendRawEvent(methodName) {
      var _window;
      if (!window.ym) throw new Error('Счётчик не инициализирован');
      for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
        args[_key - 1] = arguments[_key];
      }
      (_window = window).ym.apply(_window, [this.counterId, methodName].concat(args));
    }
  }]);
  return YaMetricsCounter;
}();